var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100vh"}},[(_vm.loading)?_c('div',{staticStyle:{"height":"100%","display":"flex","align-items":"center"}},[_c('Loader',{staticStyle:{"width":"10em","height":"10em"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }